// @ts-ignore - even tho it works in the `shared` package, when typechecking other packages, it gives error
import { createLogger } from '#/logger';
import type { Logger } from './types';

export const logger: Logger = createLogger();
